import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnFJ: CultureInfo = {
  name: 'en-FJ',
  displayName: 'English (Fiji)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-FJ',
  parent: CultureInfoEn
};
